import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background factory-grid p-6">
      <div className="w-full max-w-sm card-surface p-8">
        <h1 className="text-xl font-display font-bold text-white">Reset your password</h1>
        {done ? (
          <p className="text-sm text-muted-foreground mt-3" data-testid="forgot-done">
            If that email is registered, a reset link has been sent. Check your inbox.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-5 space-y-4">
            <div>
              <Label htmlFor="fp-email">Email</Label>
              <Input id="fp-email" data-testid="forgot-email" type="email" value={email} required
                onChange={(e) => setEmail(e.target.value)} className="mt-1.5" placeholder="you@company.ae" />
            </div>
            {error && <p className="text-sm text-rose-400">{error}</p>}
            <Button type="submit" disabled={busy} data-testid="forgot-submit"
              className="w-full bg-primary text-primary-foreground hover:bg-amber-400 font-semibold">
              {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />} Send reset link
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-6 inline-flex items-center gap-1.5 text-sm text-amber-400 hover:underline">
          <ArrowLeft className="h-4 w-4" /> Back to sign in
        </Link>
      </div>
    </div>
  );
}
